import { Font } from "@is/types";

export async function loadFont({ name, src, weight = "normal" }: Font) {
  const fontFace = new FontFace(name, `url(${src})`, {
    weight: weight,
    display: "swap",
  });

  try {
    await fontFace.load();
    document.fonts.add(fontFace);
  } catch (e) {
    console.error(`Font ${name} failed to load: `, e);
  }
}
